var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.1513C11 9.00223 10.0392 10.5568 8.74043 10.9922C8.74673 11.0318 8.75 11.0724 8.75 11.1138V21.2403C8.75 21.6598 8.41421 21.9998 8 21.9998C7.58579 21.9998 7.25 21.6598 7.25 21.2403V11.1138C7.25 11.0724 7.25327 11.0318 7.25957 10.9922C5.96079 10.5568 5 9.00223 5 7.1513C5 4.96285 6.34315 2 8 2C9.65685 2 11 4.96285 11 7.1513Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2C14.1642 2 14.5 2.29146 14.5 2.65099V8.07589H15.25V3.01284C15.25 2.59338 15.5858 2.25335 16 2.25336C16.4142 2.25336 16.75 2.5934 16.75 3.01285V8.07589H17.5V2.65099C17.5 2.29146 17.8358 2 18.25 2C18.6642 2 19 2.29146 19 2.65099V8.07589C19 9.49147 18.0439 10.6809 16.7499 11.0181V21.2405C16.7499 21.66 16.4141 22 15.9999 22C15.5856 22 15.2499 21.66 15.2499 21.2405V11.0181C13.956 10.6808 13 9.49143 13 8.07589V2.65099C13 2.29146 13.3358 2 13.75 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverware);
export default __webpack_public_path__ + "static/media/silverware.e8d525c6994c91c76be240e79c30c609.svg";
export { ForwardRef as ReactComponent };